<template>
  <!-- -->
  <div class="category-icon mini-component-show">
    <div class="category-p" v-for="(item, idx) in categories" :key="idx">
      <div class="category-item p" :style="{'color': item.textColor}">
        <div class="icon">
          <alone-image :src="item.itemImage" class="item-image"/>
        </div>
        <div class="name">{{item.text}}</div>
      </div>
      <div class="category-c">
        <div v-for="(it, i) in item.children" :key="`${idx}_${i}`" class="category-item c" :style="{'color': it.textColor, '--tag-color': it.tagColor, '--tag-background': it.tagBackground}">
          <div class="icon">
            <alone-image :src="it.itemImage" class="item-image"/>
          </div>
          <div class="name">{{it.text}}</div>
          <div class="tag">{{it.tagName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import YqIcon from "@/components/YqIcon.vue";

export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    YqIcon,
    AloneImage
  },
  data() {
    return {
      categories: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.categories = [
          {
            text: "分类1",
            itemImage: "",
            itemIcon: "iconfont_shopify",
            itemBackGround: "",
            path: "",
            size: "",
            children: [
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
            ]
          },
          {
            text: "分类2",
            itemImage: "",
            itemIcon: "iconfont_shopify",
            itemBackGround: "",
            path: "",
            size: "",
            children: [
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
            ]
          },
          {
            text: "分类3",
            itemImage: "",
            itemIcon: "iconfont_shopify",
            itemBackGround: "",
            path: "",
            size: "",
            children: [
              {text: "分类11", itemIcon: "iconfont_shopify"},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify"},
            ]
          },
          {
            text: "分类4",
            itemImage: "",
            itemIcon: "iconfont_shopify",
            itemBackGround: "",
            path: "",
            size: "",
            children: [
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
              {text: "分类11", itemIcon: "iconfont_shopify",},
            ]
          },
        ];
      } else {
        this.categories = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.category-icon {
  padding: 30px;
  background-color: #FFF;

  .category-p {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin-top: 30px;

    .category-item {
      aspect-ratio: 1/1;
      position: relative;

      .icon {
        width: 100%;
        aspect-ratio: 1/1;
        .item-image {
          width: 100%;
          aspect-ratio: 1/1;
          border: 1px solid var(--yq-border-color);
          object-fit: contain;
        }
        :deep(.alone-image) {
          .image{
            object-fit: contain !important;
          }
        }
      }

      .name {
        white-space: nowrap;
        overflow: hidden;
      }

      &.p {
        width: 100px;
        margin-right: 30px;
      }

      &.c {
        width: 80px;
        margin-right: 30px;
      }

      .tag {
        position: absolute;
        left: 0;
        top: -10px;
        padding: 2px 5px;
        border-radius: 6px;
        color: var(--tag-color);
        background-color: var(--tag-background);
        font-size: 24px;
      }
    }

    .category-c {
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>